__turbopack_context__.v({
  "Counsellor_btn": "EnrollNowSticky-module-scss-module__gzNw2W__Counsellor_btn",
  "container": "EnrollNowSticky-module-scss-module__gzNw2W__container",
  "displayNone": "EnrollNowSticky-module-scss-module__gzNw2W__displayNone",
  "download_btn": "EnrollNowSticky-module-scss-module__gzNw2W__download_btn",
  "live_chat_btn": "EnrollNowSticky-module-scss-module__gzNw2W__live_chat_btn",
  "phone_icon_btn": "EnrollNowSticky-module-scss-module__gzNw2W__phone_icon_btn",
  "root": "EnrollNowSticky-module-scss-module__gzNw2W__root",
});
